<template>
  <span v-if="secondaryText">{{secondaryText}}</span>
  <span v-else></span>
</template>

<script>
import dc from 'dc';

  /* eslint-disable */
  export default {
    name: 'dc-number',
    props: ['dimension', 'numberFormat', 'crossfilterGroup', 'valueAccessor', 'dcGroup', 'secondary', 'onChange', 'html'],

    mounted: function() {
      var self = this;
      self.initNumberDisplay();
    },

    data: function() {
      return {
        secondaryText: undefined
      };
    },

    computed: {},

    methods: {
      initNumberDisplay: function() {
        var self = this;

        var dcNumberDisplay = dc.numberDisplay(self.$el, self.dcGroup);

        dcNumberDisplay
          .dimension(self.dimension)
          .group(self.crossfilterGroup);

        if (self.numberFormat) {
          if ($.isFunction(self.numberFormat)) {
            dcNumberDisplay.formatNumber(self.numberFormat);
          } else {
            dcNumberDisplay.formatNumber(d3.format(self.numberFormat));
          }
        } else {
          dcNumberDisplay.formatNumber(d3.format("d"));
        }

        if (self.valueAccessor) {
          dcNumberDisplay.valueAccessor($.isFunction(self.valueAccessor) ? self.valueAccessor : dc.pluck(self.valueAccessor));
        }

        if (self.html) {
          dcNumberDisplay.html(self.html);
        }

        if (self.onChange) {
          dcNumberDisplay.on("pretransition", function(d) {
            self.onChange(d);

            if (self.secondary && d.data() === self.secondary.value) {
              self.secondaryText = self.secondary.text;
              $(self.$el).find('.number-display').hide();
            } else {
              self.secondaryText = undefined;
              $(self.$el).find('.number-display').show();
            }
          });
        }

        dcNumberDisplay.render();
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/DcNumber.vue